var map = {
	"./categories/actualites.svg": 49,
	"./categories/divers.svg": 50,
	"./categories/evenements.svg": 51,
	"./categories/ils-en-parlent.svg": 52,
	"./categories/medias.svg": 53,
	"./home-icon-beige-cn.svg": 54,
	"./home-icon-beige-en.svg": 55,
	"./home-icon-beige-fr.svg": 56,
	"./home-icon-green-cn.svg": 57,
	"./home-icon-green-en.svg": 58,
	"./home-icon-green-fr.svg": 59,
	"./home-icon-red-cn.svg": 60,
	"./home-icon-red-en.svg": 61,
	"./home-icon-red-fr.svg": 62,
	"./icons/close.svg": 63,
	"./icons/download.svg": 64,
	"./logo.svg": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;